import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import AspectRatio from 'react-aspect-ratio';
import YoutubePlayer from '../Youtube';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';



class DLVideoPlayer extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            activated: false,
            videoImageA: convertYouTubeIdToImg( this.props.videoId, 'webp' ),
            videoImageB: convertYouTubeIdToImg( this.props.videoId, 'jpg' ),
        };
        this.regressionCount = 0;
    }
    componentDidUpdate( prevProps ) {
        if( prevProps.videoId != this.props.videoId ) {
            this.setState( {
                videoImageA: convertYouTubeIdToImg( this.props.videoId, 'webp' ),
                videoImageB: convertYouTubeIdToImg( this.props.videoId, 'jpg' ),
            } );
        }
    }
    activatePlayer = () => {
        this.setState( { activated: true } );
    }
    catchClick = ( e ) => {
        e.preventDefault();
        this.props.onClick( e );
    }
    checkCoverImage = ( e ) => {
        if( ( this.regressionCount < 2 ) && e.target.naturalHeight <= 90 ) {
            ++this.regressionCount;
            switch ( this.regressionCount ) {
                case 1:
                    this.setState( {
                        videoImageA: convertYouTubeIdToImg( this.props.videoId, 'med/webp' ),
                        videoImageB: convertYouTubeIdToImg( this.props.videoId, 'med/jpg' ),
                    } );
                    break;
                case 2:
                    this.setState( {
                        videoImageA: convertYouTubeIdToImg( this.props.videoId, 'small/webp' ),
                        videoImageB: convertYouTubeIdToImg( this.props.videoId, 'small/jpg' ),
                    } );
                    break;
                default:
                    this.regressionCount = 3;
                    break;
            }
        }
    }
    render() {
        const { coverImage } = this.props;
        const { activated, videoImageB } = this.state;

        const movieMetaData = {
            attached_to: this.props.attachmentType,
            attached_id: this.props.attachmentId,
            video_author_id: this.props.authorId,
            ...this.props.movieMetaData,
        };

        return (
            <AspectRatio ratio="16/9" className={ style.videoPlayer } style={ this.props.style }
            onClick={ this.catchClick } >
                <div>
                    { !activated &&
                        <div className={ style.coverImage } onClick={ this.activatePlayer }>
                            <img className={ style.primaryImage }
                            onLoad={ !coverImage ? this.checkCoverImage : ()=>{} }
                            src={ !coverImage ? videoImageB : coverImage }
                            alt="cover image" />
                            <div className={ style.playIcon }>
                                <div className={ style.iconSetting }>
                                    <AspectRatio ratio='1/1'>
                                        <div  className={ style.iconWrapper }>
                                            <Icon source='fontAwesome' icon='fas/faPlayCircle' />
                                        </div>
                                    </AspectRatio>
                                </div>
                            </div>
                        </div>
                    }
                    { activated &&
                        <YoutubePlayer key={ this.props.videoId } videoId={ this.props.videoId } metaData={ movieMetaData } onActivate={ this.props.onActivate } />
                    }
                </div>
            </AspectRatio>
        );
    }
}
DLVideoPlayer.propTypes = {
    videoId: PropTypes.string.isRequired,
    coverImage: PropTypes.string,
};
DLVideoPlayer.defaultProps = {
    onClick: () => {},
    onActivate: () => {},
};

const mapStateToProps = ( state ) => {
    return {
        screenSize: state.screenSize,
    };
};

export default connect( mapStateToProps )( DLVideoPlayer );
